import React from "react";
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import { View } from "react-native";
import { appColors, appFonts, fontSize } from "../../themes/appTheme";
import CommonHeader from "../../shared/commonComponents/commonHeader";
import StaffList from "./staffList";

const StaffScreen = () => {
    const TopTab = createMaterialTopTabNavigator()


    return (
        <View style={{ flex: 1 }}>
            <CommonHeader headerName="StaffList" />
            <TopTab.Navigator
                backBehavior='none'
                initialRouteName="ActiveStaffList"
                screenOptions={{
                    tabBarLabelStyle: { fontSize: fontSize.largerFontSize, fontFamily: appFonts.bold, textTransform: 'capitalize' },
                    tabBarIndicatorStyle: { backgroundColor: appColors.primary },
                    tabBarActiveTintColor: appColors.primary,
                    tabBarInactiveTintColor: appColors.lightFontColor,
                    tabBarAndroidRipple: { borderless: false },
                }}
            >
                <TopTab.Screen
                    name="ActiveStaffList"
                    navigationKey="ActiveStaffList"
                    options={{ tabBarLabel: 'Active Staff', }}
                    initialParams={{ isActive: true }}
                    children={() => <StaffList isActive={true} />}
                />

                <TopTab.Screen
                    name="InActiveStaffList"
                    navigationKey="InActiveStaffList"
                    initialParams={{ isActive: false }}
                    options={{ tabBarLabel: 'InActive Staff' }}
                    children={() => <StaffList isActive={false} />}
                />


            </TopTab.Navigator>

        </View>

    )
}

export default StaffScreen


